import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { RiSearch2Line } from "react-icons/ri";


const CustomDataTable = ({ columns, data, title, right, mHeight }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  
  // useEffect(() => {
  //   if (!searchText) {
  //     setFilteredData(data);
  //     return;
  //   }
    
  //   const filtered = data.filter((item) =>
  //     Object.entries(item).some(([key, value]) => {
  //       if (typeof value === "string" || typeof value === "number") {
  //         return value.toString().toLowerCase().includes(searchText.toLowerCase());
  //       }
  //       return false;
  //     })
  //   );
  
  //   setFilteredData(filtered);
  // }, [searchText, data]);
  

  useEffect(() => {
    if (!searchText) {
      setFilteredData(data);
      return;
    }

    const lowerSearchText = searchText.toLowerCase();

    const isJsonString = (str) => {
      if (typeof str !== 'string') return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    };

    const searchInObject = (obj) => {
      return Object.values(obj).some((val) => {
        if (val == null) return false;

        if (typeof val === 'string' || typeof val === 'number') {
          return val.toString().toLowerCase().includes(lowerSearchText);
        }

        if (typeof val === 'object') {
          return searchInObject(val);
        }

        return false;
      });
    };

    const filtered = data.filter((item) => {
      return Object.entries(item).some(([key, value]) => {
        if (typeof value === 'string' && isJsonString(value)) {
          return searchInObject(JSON.parse(value));
        }

        if (typeof value === 'object' && value !== null) {
          return searchInObject(value);
        }

        if (typeof value === 'string' || typeof value === 'number') {
          return value.toString().toLowerCase().includes(lowerSearchText);
        }

        return false;
      });
    });

    setFilteredData(filtered);
  }, [searchText, data]);

  const handlePageChange = (page) => setCurrentPage(page);
  const handleRowsPerPageChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  // Inject serial number column
  const updatedColumns = [
    {
      name: "#",
      cell: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "60px",
      style: { fontWeight: "bold", textAlign: "center" },
    },
    ...columns,
  ];
  
  // Custom Styles
  const customStyles = {
    table: {
        style: {
          borderCollapse: "separate",
          borderSpacing: "0", // Ensures no extra spacing
          border: "none !important",
          
        },
    },
    rows: {
        style: {
            borderTop: "none !important",
          borderBottom: "0px solid #E6EBF4 !important", // Ensures bottom border is removed from rows
        },
    },
    headCells: {
        style: {
            fontSize: "14px",
            fontWeight: 800,
            borderBottom: "none !important",
          },
        },
        cells: {
          style: {
            fontSize: "14px",
            fontWeight: 400,
            borderBottom: "none !important",
            minHeight: mHeight ? mHeight : 80,
        }
    },
    pagination: {
        style: {
          borderTop: "1px solid #E6EBF4 !important", // Removes border above pagination
        },
    },
  };

  return (
    <div>
      <h3>{title}</h3>

      <div style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', gridGap: 20 }}>
        {/* Search Input */}
        <div className="table_Search_Container">
          <RiSearch2Line style={{ marginRight: "10px", fontSize: "20px" }} />
          <input
            type="text"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        {right}
      </div>

      {/* Data Table */}
      {filteredData.length > 0 ? (
        <DataTable
          // columns={columns}
          columns={updatedColumns}
          data={filteredData}
          pagination
          paginationPerPage={perPage}
          onChangePage={handlePageChange}
          paginationTotalRows={filteredData.length}
          onChangeRowsPerPage={handleRowsPerPageChange}
          // paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
        //   highlightOnHover
        //   striped
          customStyles={customStyles}
          responsive
          // fixedHeader
          // fixedHeaderScrollHeight="600px"
        />
      ) : (
        <p>No records found.</p>
      )}
    </div>
  );
};

export default CustomDataTable;
